// CardComponent.tsx

import React from "react";
import { Link } from "react-router-dom";

interface CardProps {
  imageSrc: string;
  title: string;
  description: string;
  buttonText: string;
  link:string
}

const CardComponent: React.FC<CardProps> = ({
  imageSrc,
  title,
  description,
  buttonText,
  link
}) => {
  return (
    <div className="bg-[#232325] flex flex-row   rounded-xl w-full items-center " data-aos="fade-up" data-aos-duration="1000">
      {/* <div className="px-10 pt-10 block md:hidden">
        <img
          className="w-fit md:max-w-[235.44px] max-h-[301px]"
          src={imageSrc}
          alt="Card Image"
        />
      </div> */}

      <div className="p-10 flex justify-center md:justify-start flex-col gap-7">
        <div className="px-10  pb-5 block md:hidden">
          <img
            className="w-fit md:max-w-[235.44px] max-h-[301px]"
            src={imageSrc}
            alt="Card Image"
          />
        </div>
        <div className="flex flex-col-reverse md:flex-col gap-5">
        <div className=" text-center md:text-start  text-zinc-500 text-sm font-normal uppercase leading-normal tracking-wider">
          {description}
        </div>
        <h1 className=" text-center md:text-start  text-zinc-100 text-3xl md:text-4xl font-bold  uppercase ">
          {title}
        </h1>

        </div>
        
        <Link to={link} className="sButton mx-auto md:mx-0 w-fit ">
          <div className="bText">{buttonText}</div>
        </Link>
      </div>
      <div className="px-10 pt-10 hidden md:block">
        <img
          className="w-fit md:max-w-[235.44px] max-h-[301px]"
          src={imageSrc}
          alt="Card Image"
        />
      </div>
    </div>
  );
};

export default CardComponent;
